<div [copoScroller]="{restoreAfterViewInit: false}" #scroller="copoScroller" class="sidenav-content" @routeAnimation>

	<copo-panel-header [titleHeaderText]="'eoffer.offer.and.order' | translate"></copo-panel-header>

	<div class="copo-container">

		<div class="widget-container">

			<!-- aggregate-by-status -->
			<ng-container *ngIf="!isLoading">
				<ng-container *ngFor="let aggregation of aggregations">
					<button type="button" mat-button
						*ngIf="(aggregation.status !== 'DRAFT' && user.hasService('EOFFR'))"
						class="widget-content copo-clickable" (click)="evtGoToOfferList(aggregation)">
						<div class="title widget-content-section">
							{{
							(
							'eoffer.status.'
							+ aggregation.status.toLocaleLowerCase()
							+ (aggregation.countOfferLines > 1 ? '.plural' : '')
							) | translate
							}}
						</div>

						<div class="middle widget-content-section">
							{{aggregation.sumQuantityInTonne | copoNumber:'weight':'t'}}
						</div>

						<div class="bottom widget-content-section">
							<div class="text-align-center">
								{{aggregation.countOfferLines | copoNumber:'number'}} {{
								(
								('eoffer.offerLine' + (aggregation.countOfferLines > 1 ? '.plural' : ''))
								| translate
								).toLocaleLowerCase()
								}}
							</div>
							<div class="text-align-center">
								{{aggregation.countFamilies | copoNumber:'number'}} {{
								(
								('eoffer.product.family' + (aggregation.countFamilies > 1 ? '.plural' : ''))
								| translate
								).toLocaleLowerCase()
								}}
							</div>
						</div>

					</button>
				</ng-container>
			</ng-container>

			<ng-template #loading>
				<div class="widget-content">
					<copo-loading-spinner></copo-loading-spinner>
				</div>
			</ng-template>
		</div>
	</div>
	@if (status !== 'error') {
	<div class="copo-container card-block grid-column-two-third">
		@if (status === 'loading') { <copo-loading-spinner></copo-loading-spinner> }
		@if (status === 'success') {
		<div class="card-title"><span translate>offers.proposals.price.title</span></div>
		<div class="proposal-card proposal-body-grid">
			<span class="header" translate>
				application.procurement.supplier.rfqNumber
			</span>
			<span class="header" translate>
				eorder.wizard.product.itemnumber
			</span>
			<span class="header col-2span" translate>
				order-tracking.product
			</span>
			<span class="header" translate>
				offers.proposals.price.period
			</span>
			<span class="header price" translate>
				datacenter-filter.Proposed-price
			</span>

			@if (offerLinesStream.length > 0) {
			@for (offer of offerLinesStream; track offer.opportunityID) {
			<div class="proposal-row">
				<a class="pill proposal-header-link" [routerLink]="['/offer', 'card', 'c' + offer.opportunityID]">
					{{ offer.suppOffRef }}
				</a>

				<span>{{ offer.itemNumber || UNDERSCORE }}</span>

				<span class="overflow-ellipse tooltips" [matTooltip]="offer.standardGrade">
					{{ offer.standardGrade }}
				</span>

				<span>{{ offer.dimension }}</span>
				<span class="tooltips" [matTooltip]="offer.fullPeriod">{{ offer.period }}</span>
				<span class="price">{{ offer.quantity }}</span>
			</div>
			}
			} @else {
			<div class="no-data-container">
				<i class="no-data" translate>
					offers.proposals.price.nooffer
				</i>
			</div>
			}
		</div>
		}
	</div>
	}
	<div class="service-grid-container copo-container">
		<div class="new-request-container">
			<copo-request-offer-widget *ngIf="user.hasService('EOFFR') && user.isOfferValidator()"
				headerLabel="offer.new.request.title" btnLabel="eoffer.request.new.offer" btnRouterLink="/offer/wizard"
				(click)="evtNewOffer()">
			</copo-request-offer-widget>
		</div>
	</div>

</div>